import { Injectable } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { CancellationService } from '../cancellation/cancellation.service';
import { DefaultResolver } from './default.resolver';

@Injectable()
export class CancellationResolver extends DefaultResolver implements Resolve<any> {

  constructor(
      private cancellationService: CancellationService,
      private router: Router
  ) {
     super();
  }

  resolve(route: ActivatedRouteSnapshot) {
    let routeData = JSON.parse(localStorage.getItem('routeData'));
    let step = this.getRouteParam(route, 'step');
    this.checkStep(step, routeData);
    let data = null;
    switch (+step) {
      case 1 :
          break;
      case 2 :
        break;
      case 3 :
        let producerSiret = routeData.producerSiret;
        data = this.cancellationService.getResults(routeData.takingDate, producerSiret);
        break;
      case 4 :
        break;
    }
    return data;
  }

  private checkStep(step: number, routeData): void
  {
    let newStep = step;
    if(newStep == 4 && routeData.producerSiret == null) {
      newStep--;
    }
    if(newStep == 3 && routeData.producerSiret == null) {
      newStep--;
    }
    if(newStep == 2 && routeData.producerSiret == null) {
      newStep--;
    }
    if(newStep!=step){
      this.router.navigate(['cancellation/'+newStep]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/resolvers/cancellation.resolver.ts